import React, { FC } from 'react';
import { Route, Switch, useHistory } from 'react-router';

import {
	isConfigurationReady,
	isMobilePlatformDashboardEnabled
} from 'src/common/helpers/ConfigurationHelpers';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { NotFound404Page } from 'src/common/pages/not-found-404-page/NotFound404Page';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { TableStateProvider } from 'src/common/providers/dashboard/TableStateProvider';

import { DashboardLayout } from '../components/dashboard-layout/DashboardLayout';
import { handleDashboardRedirection } from '../helpers/NavigationHelpers';
import { MobileDashboardBusinessUnits } from '../pages/business-units/MobileDashboardBusinessUnits';
import { MobileAccessibilityDashboard } from '../pages/dashboard/MobileAccessibilityDashboard';
import { MobileIssuesPage } from '../pages/issues/MobileIssuesPage';

export const MobileDashboardRoot: FC = () => {
	const history = useHistory();
	const { configuration } = useConfiguration();

	if (!isConfigurationReady(configuration)) {
		return null;
	}

	if (!isMobilePlatformDashboardEnabled(configuration)) {
		handleDashboardRedirection(history, configuration);
		return null;
	}

	return (
		<DashboardLayout showBanner={false}>
			<TableStateProvider>
				<Switch>
					<Route
						exact
						path={RoutesHelper.getMobileAccessibilityDashboardPath()}
						component={MobileAccessibilityDashboard}
					/>
					<Route
						exact
						path={RoutesHelper.getMobileDashboardIssuesPath()}
						component={MobileIssuesPage}
					/>
					<Route
						exact
						path={RoutesHelper.getMobileBusinessUnitDashboardPath()}
						component={MobileDashboardBusinessUnits}
					/>
					<Route
						path={RoutesHelper.getMobileBusinessUnitDashboardPath(':unitId')}
						component={MobileDashboardBusinessUnits}
					/>
					<Route render={() => <NotFound404Page />} />
				</Switch>
			</TableStateProvider>
		</DashboardLayout>
	);
};
